import { render, staticRenderFns } from "./NewRegionPage.vue?vue&type=template&id=dcb95b80&"
import script from "./NewRegionPage.vue?vue&type=script&lang=js&"
export * from "./NewRegionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports